export interface EnvConfig {
  ECM_URL?: string;
  ECM_API_URL?: string;
  GATEWAY_API_URL?: string;
}

export const checkEnvironment = (): EnvConfig =>
  (window as { envConfig?: EnvConfig }).envConfig ?? {};
